import React, { useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { useHistory } from "react-router-dom";
import { useResourceTabPermission } from "../../util/CommonServices";

const Resources = () => {
    const history = useHistory();
    const isBusinessUser = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userServiceDetails?.isBusinessUser);
    const productFeatureOfBIDR = useSelector((state: ApplicationState) => state.productFeatureState?.productFeatureData);

    const displaySecurityAssessment = useResourceTabPermission(productFeatureOfBIDR?.SecurityAssessmentEnabled);
    const displayCyberRiskProfile = useResourceTabPermission(productFeatureOfBIDR?.AllowWhiteHawkAssessment);
    const displayBreachReadiness = useResourceTabPermission(productFeatureOfBIDR?.BreachReadinessKitEnabled);
    const isWhiteLabeled = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isWhiteLabeled
            ? state.configurationState.configuration.partnerConfig.isWhiteLabeled
            : false
    );

    const hasEducationAndBreach = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasEducationAndBreach
            ? state.configurationState.configuration.partnerConfig.hasEducationAndBreach
            : false
    );

    let isEducationAndBreach = hasEducationAndBreach;

    useLayoutEffect(() => {
        let redirectPath = "/resources/education";
        if (isBusinessUser) {
            if (displaySecurityAssessment) {
                redirectPath = "/resources/security-assessment";
            } else if (displayCyberRiskProfile) {
                redirectPath = "/resources/cyber-risk-profile";
            } else if (displayBreachReadiness) {
                redirectPath = "/resources/breach-readiness";
            }
        } else if (!isEducationAndBreach) {
            redirectPath = "/resources/calculators";
        }
        
        const initialUrl = window.location.href + redirectPath.split("/resources/")[1];
        sessionStorage.setItem("initialUrl", encodeURIComponent(initialUrl));
        history.replace(redirectPath);
    }, []);

    return <div className="box offset-padding box-content box loading"></div>;
};

export default Resources;
